import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-down",
  "use": "icon_chevron-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_chevron-down\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.40746 5.32267C2.78153 4.99536 3.35012 5.03326 3.67743 5.40733L10.0001 12.6333L16.3228 5.40733C16.6501 5.03326 17.2187 4.99536 17.5928 5.32267C17.9668 5.64998 18.0047 6.21857 17.6774 6.59264L10.0001 15.3667L2.32279 6.59264C1.99548 6.21857 2.03338 5.64998 2.40746 5.32267Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol